import { IIndustryComponentProps } from "../components/common/industry-we-serve/interfaces/IIndustryComponentProps";
import { faCity, faGears, faPlane, faShoppingCart, faUserDoctor, faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import { IStepComponentProps } from "../components/common/step/interfaces/IStepComponentProps";
import { IReasonComponentProps } from "../components/common/reason/interfaces/IReasonComponentProps";

export default abstract class HomePagePropsService {
  public static getIndustriesWeServeProps(phrases: any): Array<IIndustryComponentProps> {
    return [
      {
        liClasses: ["slide-in"],
        divId: "home__travel-and-hospitality-container",
        icon: faPlane,
        description: phrases[42]
      },
      {
        divId: "home__healthcare-and-medical",
        icon: faUserDoctor,
        description: phrases[43]
      },
      {
        divId: "home__retail-and-ecommerce",
        icon: faShoppingCart,
        description: phrases[44]
      },
      {
        divId: "home__education-and-elearning",
        icon: faUserGraduate,
        description: phrases[45]
      },
      {
        divId: "home__manufacturing-and-logistics",
        icon: faGears,
        description: phrases[46]
      },
      {
        divId: "home__real-estate",
        icon: faCity,
        description: phrases[47]
      }
    ];
  }

  public static getStepsProps(phrases: any): Array<IStepComponentProps> {
    return [
      {
        heading: phrases[49],
        description: phrases[50],
        index: 1,
        isLastStep: false
      },
      {
        heading: phrases[51],
        description: phrases[52],
        index: 2,
        isLastStep: false
      },
      {
        heading: phrases[53],
        description: phrases[54],
        index: 3,
        isLastStep: false
      },
      {
        heading: phrases[55],
        description: phrases[56],
        index: 4,
        isLastStep: true
      },
    ];
  }

  public static getReasonsProps(phrases: any):Array<IReasonComponentProps> {
    return [
      {
        heading: phrases[57],
        description: phrases[58],
      },
      {
        heading: phrases[59],
        description: phrases[60],
      },
      {
        heading: phrases[61],
        description: phrases[62],
      },
      {
        heading: phrases[63],
        description: phrases[64],
      },
      {
        heading: phrases[65],
        description: phrases[66],
      },
    ];
  }
};
